import React, { FC } from 'react';
import { Box, Container, makeStyles, Theme, Typography, Grid } from '@material-ui/core';
import { ProjectCard } from 'components/atoms';
import { CardProps } from 'components/atoms/ProjectCard';

interface RelatedProjectProps {
  listCards: Array<CardProps>;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(26, 0, 42),
    marginTop: theme.spacing(42),
  },
  divider: {
    width: 100,
    height: 1,
    backgroundColor: theme.palette.primary.main,
    marginTop: theme.spacing(6),
  },
  textBox: {
    textAlign: 'center',
    margin: '0 auto',
    marginBottom: theme.spacing(10),
  },
  title: {
    color: theme.palette.primary.dark,
    fontWeight: 600,
  },
}));

const RelatedProjectsSection: FC<RelatedProjectProps> = ({ listCards }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Container fixed>
        <Grid container spacing={5}>
          <Box className={classes.textBox} data-aos="fade-up">
            <Typography variant="h2" className={classes.title}>
              Related Projects
            </Typography>
            <Box className={classes.divider} margin="0 auto" />
          </Box>
          {listCards.map(({ title, subtitle, text, image, width, height, link }, index, array) => (
            <Grid item md={index === array.length - 3 ? 12 : 6} sm={12} key={index}>
              <ProjectCard
                subtitle={subtitle}
                title={title}
                text={text}
                image={image}
                width={width}
                height={height}
                link={link}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default RelatedProjectsSection;
